/**
 * @autogenerated
 *
 * WARNING: This file is automatically generated based on Contentful schema.
 * DO NOT modify this file manually - your changes will be overwritten.
 *
 * To regenerate this file, run: `yarn contentful generate`.
 * To customize the generated code:
 *   - Modify the schema in Contentful and regenerate.
 *   - Override this module in higher-level packages.
 */

import gql from 'graphql-tag';

import {BaseHeaderFragment} from '@amblique/contentful/app/contentful/fragments/header/base-header.fragment';
import {ImageFragment} from '@amblique/contentful/app/contentful/fragments/image/image.fragment';
import {LinkFragment} from '@amblique/contentful/app/contentful/fragments/link/link.fragment';
import {NavigationMenuFragment} from '@amblique/contentful/app/contentful/fragments/navigation-menu/navigation-menu.fragment';
import {RichTextBlockFragment} from '@amblique/contentful/app/contentful/fragments/rich-text-block/rich-text-block.fragment';
import {SectionPanelFragment} from '@amblique/contentful/app/contentful/fragments/section-panel/section-panel.fragment';

export const FullHeaderFragment = gql`
  ${BaseHeaderFragment}
  ${ImageFragment}
  ${LinkFragment}
  ${NavigationMenuFragment}
  ${RichTextBlockFragment}
  ${SectionPanelFragment}

  fragment FullHeaderFragment on Header {
    ...BaseHeaderFragment

    logo {
      ...ImageFragment
    }
    mainNavigation {
      ...NavigationMenuFragment
    }
    promoBannersCollection {
      items {
        __typename
        ... on RichTextBlock {
          ...RichTextBlockFragment
        }
        ... on SectionPanel {
          ...SectionPanelFragment
        }
      }
    }
    utilityLinksCollection {
      items {
        __typename
        ... on Link {
          ...LinkFragment
        }
      }
    }
  }
`;
